import React from 'react';
import { Button } from './Button';
import { ArrowDown } from 'lucide-react';
export function PersuasiveCTA() {
  return <section className="py-8 md:py-12 px-4 bg-white border-y-2 border-brand-section text-center" data-id="element-168">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-169">
        <h2 className="text-2xl md:text-4xl font-black text-brand-text mb-3 uppercase tracking-tight" data-id="element-170">
          LA <span className="text-brand-primary" data-id="element-171">SOLUCIÓN</span>
        </h2>

        <p className="text-sm md:text-base text-brand-steel font-medium mb-6 max-w-2xl" data-id="element-172">
          Estás a un solo paso de acceder al conocimiento que separa a los
          instaladores comunes de los verdaderos especialistas industriales.
        </p>

        <div className="w-full max-w-lg mx-auto mb-4" data-id="element-173">
          <Button className="w-full text-base md:text-lg py-3 md:py-4" pulse={true} data-id="element-174">
            DESCARGAR INMEDIATAMENTE
          </Button>
        </div>

        <div className="flex flex-col items-center mt-2 animate-bounce" data-id="element-175">
          <span className="text-[10px] md:text-xs font-bold text-brand-steel uppercase tracking-widest mb-1.5" data-id="element-176">
            Sigue leyendo para ver todo lo que incluye
          </span>
          <ArrowDown className="w-5 h-5 text-brand-primary" data-id="element-177" />
        </div>
      </div>
    </section>;
}